'use strict';
import * as storage from 'redux-storage';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import {PRODUCTION} from './constants/environments';
import {onLocationChangeStart, onLocationChangeSuccess} from './actions';
import {epicMiddleware} from './epics';
import {rootReducer} from './reducers';
import {engine, storageMiddleware} from './redux-storage';
import {rootLogger} from './logger';

export const configRedux = [
  '$ngReduxProvider',
  $ngReduxProvider => {
    const middleware = [
      'ngUiRouterMiddleware',
      thunk, /* Required for ngUiRouterMiddleware. DO NOT USE */
      epicMiddleware,
      storageMiddleware,
    ];

    if (process.env.ENVIRONMENT !== PRODUCTION) {
      middleware.push(createLogger({
        level: 'info',
        collapsed: true,
      }));
    }

    if (process.env.ENVIRONMENT !== PRODUCTION && window.__REDUX_DEVTOOLS_EXTENSION__) {
      $ngReduxProvider.createStoreWith(rootReducer, middleware, [
        window.__REDUX_DEVTOOLS_EXTENSION__(),
      ]);
    } else {
      $ngReduxProvider.createStoreWith(rootReducer, middleware);
    }
  }];

ReduxBootstrapper.$inject = [
  '$rootScope',
  '$ngRedux',
];

export function ReduxBootstrapper($rootScope, $ngRedux) {
  $rootScope.$on('$locationChangeStart', function (...args) {
    $ngRedux.dispatch(onLocationChangeStart(...args));
  });
  $rootScope.$on('$locationChangeSuccess', function (...args) {
    $ngRedux.dispatch(onLocationChangeSuccess(...args));
  });

  const load = storage.createLoader(engine);
  const loaded = load($ngRedux).catch(err => {
    rootLogger.error({err}, 'Failed to initialize redux-storage');
    return null;
  });

  return {
    loaded: () => loaded,
  };
}



// WEBPACK FOOTER //
// ./src/js/config/configRedux.js